import {IAutoOrderStockItem, keyToTitle, StockItem} from '../../../../shared-utilities/models-old/datastructures';
import {getStockValueType} from '../../../../shared-utilities/models-old/stock-stuff/stock-item-value-type';
import {StockFunctions} from '../../../../shared-utilities/functions-old/stock-functions';
import {IAutoOrderOrderItem} from '../index';

export const AO_STOCK_INFO_COLUMNS = [
  'stockId',
  'created',
  'desc',
  'dlvColl',
  'gp1',
  'purchaseOrder',
  'onHand',
  'lastSold',
  'latestCost',
  'onHoldCode',
  'packSize',
  'lineColourCode',
  'ordLvl',
  'orderQuantity',
  'sellPriIncl1',
  'suppCode',
  'unitsYear',
  'unitsMonthAvg',
  'regularSuppCode',
  'noDecimal',
  '_tags',
  'lastStockTake',
  'modified',
  'orderQty',
] as const;

export const AO_EXPORT_COLUMNS = [
  ...AO_STOCK_INFO_COLUMNS,
  'code',
] as const;

export interface AOStockInfo extends Pick<IAutoOrderStockItem, typeof AO_EXPORT_COLUMNS[number]> {
  flagged?: boolean;
  poOnHold?: boolean;
}

export type FormattedStockInfoStrings = Record<(keyof Omit<AOStockInfo, 'flagged' | 'poOnHold' | '_tags' | 'noDecimal' | 'stockId'>) |
    (keyof Omit<IAutoOrderOrderItem, 'new'>), string>;

export const aoKeyTextAlign = (key: keyof FormattedStockInfoStrings): 'left' | 'right' | 'center' => {
  const align = StockFunctions.itemFieldTextAlign(key as keyof StockItem);
  return align ? align : 'right';
};

export const AO_KEY_2_TITLE: { [key in keyof FormattedStockInfoStrings]: string } = {
  created: keyToTitle.created,
  code: keyToTitle.code,
  desc: keyToTitle.desc,
  dlvColl: keyToTitle.dlvColl,
  gp1: keyToTitle.gp1,
  purchaseOrder: keyToTitle.purchaseOrder,
  onHand: keyToTitle.onHand,
  lastSold: keyToTitle.lastSold,
  latestCost: keyToTitle.latestCost,
  onHoldCode: keyToTitle.onHoldCode,
  packSize: keyToTitle.packSize,
  lineColourCode: keyToTitle.lineColourCode,
  ordLvl: keyToTitle.ordLvl,
  orderQuantity: 'Order Quantity',
  unitsYear: keyToTitle.unitsYear,
  unitsMonthAvg: 'Average Monthly Units',
  regularSuppCode: keyToTitle.regularSuppCode,
  mainSupplier: 'Main Supplier',
  orderQty: 'To Order',
  lastStockTake: 'Last Stock Take',
  modified: 'Modified',
  outOfStock: 'Times Out Stock',
  maxSold: 'Max Sold',
  netSold: 'Nett Sold',
  suppCode: keyToTitle.suppCode,
  sellPriIncl1: keyToTitle.sellPriIncl1,
  qtyDiff: 'Suggested Order',
  maxReturned: 'Max Returned',
  negativeDays: 'Days Negative',
  zeroDays: 'Days Zero',
} as const;

export const formatAOStockInfoValues = (stockItem: AOStockInfo, orderItem: IAutoOrderOrderItem): FormattedStockInfoStrings => {
// Todo make this faster formatAOStockInfoValues
  const formatted = {} as FormattedStockInfoStrings;
  // All values of AOStockInfo that are keys of StockItem can be formatted. If they are not they don't need to be.

  Object.keys(stockItem).forEach((key: keyof AOStockInfo) => {
    const valueType = getStockValueType(key as keyof StockItem);
    if (!valueType) {
      return;
    }
    switch (valueType) {
      case 'string':
        formatted[key] = stockItem[key];
        break;
      case 'number':
        if (typeof stockItem[key] === 'number') {
          formatted[key] = stockItem[key] ? (stockItem[key]) : 0;
        } else if (typeof stockItem[key] === 'boolean') {
          formatted[key] = stockItem[key] ? 1 : 0;
        } else {
          formatted[key] = 'NaN';
        }
        break;
      case 'date':
        formatted[key] = stockItem[key]
          ? new Date(stockItem[key] as string).toLocaleDateString(
            'en-GB',
            {weekday: 'short', day: '2-digit', month: 'short', year: 'numeric'},
          )
          : null;
        break;
      case 'boolean':
        formatted[key] = stockItem[key] ? 'T' : 'F';
        break;
      case 'string[]':
        break;
      default:
        break;
    }
  });
  Object.keys(orderItem).forEach((key: keyof IAutoOrderOrderItem) => {
    if (key === 'new') {
      return;
    }
    if (orderItem.new === 'ADDED') {
      formatted[key] = 'NaN';
      return;
    } else { // PERIOD-2
      const num = +orderItem[key];

      if (num - Math.floor(num) === 0) {
        formatted[key] = '' + Math.floor(num);
        return;
      }
      formatted[key] = num.toFixed(2);
    }
  });
  return formatted;

};
